// src/pages/xray/XrayLobby/TabTrafficPass.js
import React from 'react';

const TabTrafficPass = ({
  selectedTabsPassthrough,
  setSelectedTabsPassthrough,
  proxyARPRulesLimits,
  passthroughRulesLimits,
}) => {
  return (
    <>
      <div className="tabs mt-6 flex border-b">
        {['Proxy ARP', 'Passthrough Rules'].map((label, index) => (
          <label
            key={index}
            className={`cursor-pointer px-2 py-1 border-t border-r border-l border-red-600 bg-red-300 ml-1 rounded-t-md ${
              selectedTabsPassthrough === `tabsPassthrough${index + 1}`
                ? 'border-b-0 font-bold'
                : 'border-red-600 bg-red-600 hover:bg-red-700 transition-colors duration-200 text-white'
            }`}
          >
            <input
              type="radio"
              className="hidden"
              name="tabs-group"
              checked={
                selectedTabsPassthrough === `tabsPassthrough${index + 1}`
              }
              onChange={() =>
                setSelectedTabsPassthrough(`tabsPassthrough${index + 1}`)
              }
            />
            {label}
          </label>
        ))}
      </div>

      <div className="px-6 py-2 bg-white shadow-lg rounded-lg">
        {selectedTabsPassthrough === 'tabsPassthrough1' && (
          <div>
            <h1 className="font-bold text-2xl p-2">PROXY ARP</h1>
            <pre className="bg-gray-100 p-4 rounded-md border">
              {proxyARPRulesLimits || 'No Proxy ARP rules available'}
            </pre>
          </div>
        )}

        {selectedTabsPassthrough === 'tabsPassthrough2' && (
          <div>
            <h1 className="font-bold text-2xl p-2">Passthrough Rules</h1>
            <pre className="bg-gray-100 p-4 rounded-md border">
              {passthroughRulesLimits || 'No Passthrough Rules available'}
            </pre>
          </div>
        )}
      </div>
    </>
  );
};

export default TabTrafficPass;
